import BaseService from '../../base/base_service';
import Model from './themes_model';
import * as Consts from './themes_consts';
import {SYSTEM_EVENTS} from '../../events/events';
import DOM from '../../utils/dom';
import _ from '../../utils/underscore';

/**
 *
 *
 *
 */
class ThemesService extends BaseService {
	/**
     * @static
     * @type {string}
     */
	static CLASS = 'ThemesService';


		/**
		 * @property
		 * @type {null}
		 * @private
		 */
    _model = null;


		/**
		 *
		 * @param params
		 */
    init(params) {
		 super.init(params);
		 this._subscribe();
		 this._model = Model.create(params);
	}


	/**
     * Update the themes classes according to user preferences.
     *
     * @public
     **/
	changeThemeAccordingToUserPreferences() {
		let userPreferences = this._model.getUserPreferences();

		// Finish if no user preferences.
		if (!userPreferences) {
			return;
		}

		let userPrefernceAfterRenaming = this._renameAllToIncludeAllPath(userPreferences);
		let output = [];

		// Search and override the property in every relevant class.
		let brandKey = this._getThemesBrandKey();
		for (var index = 0; index < Consts.THEMES_CLASSES_LIST.length; index++) {
			let classPropertiesChangedFlag = false;
			let currentClass = Consts.THEMES_CLASSES_LIST[index];

            currentClass = this._getThemesBrandedClass(currentClass, brandKey);
			let classStyle = [];
			let currentClassProperties = currentClass.properties;
            let setOfUserPreferences = new Set(currentClassProperties.map((property) => {
                return property.value;
            }));

            // Convert user preferences to real language.
            setOfUserPreferences.forEach((propertyName) => {
                this._changeValueAccordingToUserValue(propertyName, userPrefernceAfterRenaming);
			});

            currentClassProperties.forEach((property) => {
                for (var propertyName in userPrefernceAfterRenaming) {
					if (property.value && property.value.toLowerCase() === propertyName) {
                        if (!classPropertiesChangedFlag) {
                            classStyle.push('.' + currentClass.className + ' {');
                        }

                        classPropertiesChangedFlag = true;
                        if (!this._checkLimits(propertyName, userPrefernceAfterRenaming)) {
                            break;
                        }

                        // Add px suffix for sizes.
                        this._addSuffix(propertyName, userPrefernceAfterRenaming);
						if (_.includes(propertyName, 'icons')) {
							if(_.includes(propertyName, 'iconsheight')) {
								classStyle.push('height:' + userPrefernceAfterRenaming[propertyName] + 'px;');
							} else if(_.includes(propertyName, 'iconswidth')) {
								classStyle.push('width:' + userPrefernceAfterRenaming[propertyName] + 'px;');
							} else {
								// Override this property in the class.
								classStyle.push(property.name + ': url(' + userPrefernceAfterRenaming[propertyName] + ');');
							}
						} else {
                            // Override this property in the class.
                            classStyle.push(property.name + ':' + userPrefernceAfterRenaming[propertyName] + ';');
						}

                    }
                }
			});

			if (classPropertiesChangedFlag) {
				classStyle.push('}');
				output = output.concat(classStyle);
			}
		}
		// Add the override properties for this class to DOM.
		if (output.length > 0) {
            DOM.injectStyleToDOM(output.join(''));
		}
	}

	_getThemesBrandKey() {
        return this.serviceFactory.skinService().getBrandID() + '_' + this.serviceFactory.skinService().getSubBrandID();
	}


	_getThemesBrandedClass(defaultClass, brandKey) {
        let brandedClasses = Consts.BRANDED_THEMES[brandKey];
        if (!brandedClasses) {
            return defaultClass;
        }
        let brandedClass = brandedClasses.find((brandedClass) => {
			return brandedClass.className === defaultClass.className;
		});

        if (!brandedClass) {
        	return defaultClass;
		}
        let mergedClass = Object.assign({}, defaultClass);

        mergedClass.properties.forEach((prop) => {
        	let brandedProp = brandedClass.properties.find((brandProperty) => {
                return brandProperty.name === prop.name;
			});
        	if (brandedProp) {
                prop.value = brandedProp.value;
			}
		});

        return mergedClass;
	}


	/**
     * return the user preferences.
     *
     * @public
     */
	getUserPreferences() {
		return this._model.userPreferences;
	}


	/**
     * Return text alignment from user preferences or default one (center)
      * @returns {*}
     */
	getTextAlignment() {
		if (this._model.userPreferences && this._model.userPreferences.textAlignment) {
			return this._model.userPreferences.textAlignment;
		} else {
			return 'center';
		}
	}


	/**
	 *
	 * @returns Merged object from sdk defaults and user prefferences for fonts
	 */
	getFonts() {
		return this._model.getMergedPreferences().fonts;
	}


    /**
	 * @returns Merged object from sdk defaults and user preferences for captcha
     * @returns {*}
     */
	getCaptchaTheme() {
		return this._model.getMergedPreferences().captcha;
	}


	/**
	 *
	 * @returns Merged object from sdk defaults and user prefferences for colors
	 */
	getColors() {
		return this._model.getMergedPreferences().colors;
	}


    /**
	 *
	 * @returns Merged object from sdk defaults and user prefferences for font sizes
     */
	getFontSizes() {
		return this._model.getMergedPreferences().fontSizes;
	}


	/**
     * Change the name of the param to be appropriate to the themes classes list
     *
     * @private
     */
	_renameAllToIncludeAllPath(themes) {
		let themesWithNewNames = {};

		for (var propertyName in themes) {
			this._renameToIncludeAllPath(propertyName, themes[propertyName], themesWithNewNames);
		}

		return themesWithNewNames;
	}


	/**
     * Subscribe initialize application startup events.
     */
	_subscribe() {
		this.onSystemEvent(SYSTEM_EVENTS.ON_INIT_COMPLETE, this.changeThemeAccordingToUserPreferences);
	}


    _addSuffix(propertyName, userPrefernceAfterRenaming) {
        if (propertyName.toLowerCase().includes('fontsizes_') && userPrefernceAfterRenaming[propertyName] && !_.isString(userPrefernceAfterRenaming[propertyName])) {
            // Add px suffix to font size.
            userPrefernceAfterRenaming[propertyName] = userPrefernceAfterRenaming[propertyName].toString() + 'px';
        }
    }


    _changeValueAccordingToUserValue(propertyName, userPrefernceAfterRenaming) {
		let propertyNameLowerCase = propertyName.toLowerCase();

		if ('gameframeanonhorizontalposition' === propertyNameLowerCase || 'gameframerealhorizontalposition' === propertyNameLowerCase) {
            // The align is with flex so we should convert it to flex language.
            if (userPrefernceAfterRenaming[propertyNameLowerCase] === 'right') {
                userPrefernceAfterRenaming[propertyNameLowerCase] = 'flex-end';
            } else if ((userPrefernceAfterRenaming[propertyNameLowerCase] === 'left')) {
                userPrefernceAfterRenaming[propertyNameLowerCase] = 'flex-start';
            }
        } else if ('gameframerealsize' === propertyNameLowerCase || 'gameframeanonsize' === propertyNameLowerCase) {
            userPrefernceAfterRenaming[propertyNameLowerCase] += ' !important';
		} else if ('historytable_sizepc' === propertyNameLowerCase) {
            userPrefernceAfterRenaming[propertyNameLowerCase] = (1280 * userPrefernceAfterRenaming[propertyNameLowerCase]).toString() + 'px';
		}
	}

	/**
     * Change the name of the param to be appropriate to the themes classes list
     *
     * @private
     */
	_renameToIncludeAllPath(themeName, themeContent, themesWithNewNames) {
		if (!_.isObject(themeContent)) {
            themesWithNewNames[themeName.toLowerCase()] = themeContent;
			return;
		}

		for (var propertyName in themeContent) {
			let newPath = themeName + '_' + propertyName;

			if (!_.isObject(themeContent[propertyName])) {
				themesWithNewNames[newPath.toLowerCase()] = themeContent[propertyName];
			} else {
				this._renameToIncludeAllPath(newPath, themeContent[propertyName], themesWithNewNames);
			}
		}
	}


	/**
     * Check if the value is forbidden is yes change to the max limit.
     *
     * @private
     */
	_checkLimits(propertyName, property) {
		let fontsSizesLimits = {'xlarge': 30, 'large': 25, 'largesecondary': 25, 'medium': 20, 'mediumsecondary': 20, 'small': 20, 'smallsecondary': 20};
		let borderSizesLimits = 5;
		let propertyValue = property[propertyName];
		let firstProperty = propertyName.split('_')[0];

		if (firstProperty.toLowerCase().includes('fontsizes')) {
            let secondPropertyName = propertyName.split('_')[1];

            if (!secondPropertyName) {
                return true;
            }

            let maxValue = fontsSizesLimits[secondPropertyName];

            // If the value is forbidden change to the maximum.
            if (propertyValue > maxValue) {
                delete property[propertyName];
                return false;
            }
		} else if ('bordersize' === firstProperty.toLowerCase()) {
            if (propertyValue > borderSizesLimits) {
                delete property[propertyName];
                return false;
            }
        }

        return true;
	}
}

export default ThemesService;